export interface ApprovalStatusCheckboxProps {
  checked: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export const ApprovalStatusCheckbox = ({
  checked,
  onToggle,
  disabled,
}: ApprovalStatusCheckboxProps) => {
  return (
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onChange={onToggle}
      className="cursor-pointer w-4 h-4 accent-green-600 disabled:cursor-not-allowed"
    />
  );
};
